// material-ui
import Link from '@mui/material/Link';

// project imports
import Logo from 'ui-component/Logo';

// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection() {
  return (
    <Link aria-label="theme-logo">
      <Logo />
    </Link>
  );
}
